// extracted by mini-css-extract-plugin
export default {"background":"InfoModal_background__dmvCx","modal":"InfoModal_modal__-2WCB","btn_main":"InfoModal_btn_main__nPdiF"};